const s = {
  name: "CashRegister",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M37,2H27V0h10V2z"/>
		<path class="st0" d="M25.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C24.7,9.8,25.3,10.3,25.3,11z"
			/>
		<path class="st0" d="M28,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C26.8,11.7,27.3,12.3,28,12.3z"
			/>
		<path class="st0" d="M33.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C32.7,9.8,33.3,10.3,33.3,11z"
			/>
		<path class="st0" d="M24,16.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,15.7,23.3,16.3,24,16.3z"
			/>
		<path class="st0" d="M29.3,15c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,13.8,29.3,14.3,29.3,15z"
			/>
		<path class="st0" d="M32,16.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,15.7,31.3,16.3,32,16.3z"
			/>
		<path class="st0" d="M25.3,19c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,17.8,25.3,18.3,25.3,19z"
			/>
		<path class="st0" d="M28,20.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,19.7,27.3,20.3,28,20.3z"
			/>
		<path class="st0" d="M33.3,19c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C32.7,17.8,33.3,18.3,33.3,19z"
			/>
		<path class="st0" d="M17,30h6v-2h-6V30z"/>
		<path class="st0" d="M37,4H3v20H0v10h40V24h-3V4z M35,6v18H21V6H35z M19,24H5V6h14V24z M2,26h36v6H2V26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CashRegister
};
